/* eslint-disable no-loop-func */
import React, { useState, useEffect } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PropTypes from "prop-types";

const StyledMenu = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.custom.text,
  },
}));
const typesList = [
  { id: 0, name: "Planned" },
  { id: 1, name: "Unplanned" },
  { id: 2, name: "Comment" },
];
function StateHistoryTypeMenu({ typeName, onChooseType }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [name, setName] = useState(typeName ? typeName : "");
  const [anchorPage, setAnchorPage] = useState(null);

  useEffect(() => {
    if (typesList && typesList.length > 0) {
      const objectType = typesList.find((x) => x.name.toString() === typeName);
      setName(objectType ? objectType.name : "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeName]);
  const handleOpenMenu = (event) => {
    setAnchorPage(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorPage(null);
  };
  const handleChooseName = (event, item) => {
    setName(item.name);
    onChooseType(item.name);
    setAnchorPage(null);
  };
  return (
    <>
      <Tooltip title="Open settings">
        <Button
          variant="outlined"
          onClick={handleOpenMenu}
          sx={{
            width: "100%",
            height: "56px",
            backgroundColor: "transparent",
            border: 1,
            borderColor: theme.palette.custom.borderColor,
            borderRadius: "11px",
            color: theme.palette.custom.text,
            justifyContent: "space-between",
            "&:hover": {
              backgroundColor: theme.palette.custom.buttonHoverColor,
              color: theme.palette.custom.buttonHoverTextColor,
              boxShadow: "none",
            },
          }}
          endIcon={
            <KeyboardArrowDownIcon
              sx={{
                font: "inherit",
                color: theme.palette.custom.text,
                "&:hover": {
                  backgroundColor: theme.palette.custom.buttonHoverColor,
                  color: theme.palette.custom.buttonHoverTextColor,
                  boxShadow: "none",
                },
              }}
            />
          }
        >
          {name !== "" ? t(name) : t("Type")}
        </Button>
      </Tooltip>
      <StyledMenu
        id="menu-appbar"
        anchorEl={anchorPage}
        open={Boolean(anchorPage)}
        onClose={handleCloseMenu}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {typesList &&
          typesList.map((item, index) => (
            <MenuItem key={index} onClick={(e) => handleChooseName(e, item)}>
              <Typography textAlign="center">{t(item.name)}</Typography>
            </MenuItem>
          ))}
      </StyledMenu>
    </>
  );
}
StateHistoryTypeMenu.propTypes = {
  typeName: PropTypes.string,
  onChooseType: PropTypes.func,
};

export default StateHistoryTypeMenu;
